<template>
  <div class="modal-billing">
    <!-- <b-modal
      id="modal-billing"
      v-model="showModalBilling"
      size="xl"
      centered
      :title="typeModalBilling === 'ADD' ? 'Ingresa la nueva facturación' : 'Editar facturación'"
      hide-footer
      @close="onReset"
    > -->
      <form ref="form-billing" @submit="onSubmit" @reset="onReset">
        <div class="row">
          <div class="col-12">
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="warning"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
            >
              No se encontraron resultados.
            </b-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-6 col-sm-6">
            <label class="form-group w-100" for="input-businessIdentifier">
              <div class="d-flex justify-content-between">
                <b>RUC*</b>
                <small
                  v-if="userBilling.businessIdentifier && userBilling.businessIdentifier.length < 11"
                  classs="mb-2"
                  style="color: #e53935 !important;"
                >
                  Debe tener 11 dígitos
                </small>
              </div>
              <b-input-group>
                <b-form-input
                  trim
                  v-model="userBilling.businessIdentifier"
                  type="text"
                  class="form-control"
                  maxlength="11"
                  minlengh="11"
                  required
                  @keypress="validateNumber"
                  @paste="handlePaste($event, 'numeric')"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="info"
                    :disabled="disabledSearch"
                    @click="verifySunat(userBilling.businessIdentifier, 'RUC')"
                    >Buscar</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </label>
          </div>
          <div class="col-6 col-sm-6">
            <label class="form-group w-100" for="input-businessName">
              <b>Nombre comercial*</b>
              <b-form-input
                trim
                v-model="userBilling.businessName"
                for="input-businessName"
                type="text"
                class="form-control"
                required
                maxlength="50"
                minlengh="3"
                @keypress="validateText($event, userBilling.businessName)"
                @paste="handlePaste($event, 'text')"
              ></b-form-input>
            </label>
          </div>
          <div class="col-6 col-sm-6">
            <label class="form-group w-100" for="input-address">
              <b>Dirección*</b>
              <b-form-input
                trim
                v-model="userBilling.address"
                id="input-address"
                type="text"
                class="form-control"
                required
                maxlength="50"
                minlengh="3"
                @paste="handlePaste($event, 'alphanumeric')"
              ></b-form-input>
            </label>
          </div>
          <div class="col-6 col-sm-6">
            <label class="form-group w-100" for="input-addressDepartment">
              <b>Departamento*</b>
              <b-form-input
                trim
                v-model="userBilling.addressDepartment"
                id="input-addressDepartment"
                type="text"
                class="form-control"
                maxlength="50"
                minlengh="3"
                required
                @keypress="validateText($event, userBilling.addressDepartment)"
                @paste="handlePaste($event, 'text')"
              ></b-form-input>
            </label>
          </div>
          <div class="col-6 col-sm-6">
            <label class="form-group w-100" for="input-addressProvince">
              <b>Provincia*</b>
              <b-form-input
                trim
                v-model="userBilling.addressProvince"
                id="input-addressProvince"
                type="text"
                class="form-control"
                maxlength="50"
                minlengh="3"
                required
                @keypress="validateText($event, userBilling.addressProvince)"
                @paste="handlePaste($event, 'text')"
              ></b-form-input>
            </label>
          </div>
          <div class="col-6 col-sm-6">
            <label class="form-group w-100" for="input-addressDistrict">
              <b>Distrito*</b>
              <b-form-input
                trim
                v-model="userBilling.addressDistrict"
                id="input-addressDistrict"
                type="text"
                class="form-control"
                maxlength="50"
                minlengh="3"
                required
                @keypress="validateText($event, userBilling.addressDistrict)"
                @paste="handlePaste($event, 'text')"
              ></b-form-input>
            </label>
          </div>
          <div class="col-6 col-sm-6">
            <label class="form-group w-100" for="input-email">
              <b>Correo empresarial*</b>
              <b-form-input
                trim
                v-model="userBilling.email"
                id="input-email"
                type="email"
                class="form-control"
                maxlength="50"
                minlengh="3"
                required
                @paste="handlePaste($event, 'email')"
              ></b-form-input>
            </label>
          </div>
        </div>

        <!-- <div class="form-billing-buttons">
          <b-button size="md" variant="success" type="submit"> Guardar </b-button>
        </div> -->
      </form>
    <!-- </b-modal> -->
  </div>
</template>
<script>
import api from '../../api';
export default {
  name: 'ModalBilling',
  data() {
    return {
      //alert
      dismissSecs: 5,
      dismissCountDown: 0
    };
  },
  computed: {
    showModalBilling() {
      return this.$store.state.billing.showModalBilling;
    },
    typeModalBilling() {
      return this.$store.state.billing.typeModal;
    },
    userBilling() {
      return this.$store.state.billing.userBilling;
    },
    userId() {
      return this.$store.state.auth.user.id;
    },
    disabledSearch() {
      if (!this.userBilling) return false;
      return this.userBilling.businessIdentifier &&
        this.userBilling.businessIdentifier.length === 11
        ? false
        : true;
    }
  },
  methods: {
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    async onSubmit(event) {
      event.preventDefault();
      const userId = this.userBilling.userId;
      let data = { ...this.userBilling };
      data.options = 'REGULAR';
      if (this.typeModalBilling === 'ADD') {
        data.userId = userId;
        if (!userId) {
          let array = [];
          array.push(data);
          this.$store.dispatch('setBillings', array);
        }
        try {
          this.$store.dispatch('changeLoadingJoinnus', true);
          await api.createBilling(data);
          const response = await api.getBillings(userId);
          this.$store.dispatch('setBillings', response.userBillingDetails);
        } catch (error) {
          console.log(error);
        } finally {
          this.$store.dispatch('changeLoadingJoinnus', false);
          this.$store.dispatch('resetFormBilling');
        }
      } else {
        const idBilling = this.userBilling.id;
        delete data.createdAt;
        delete data.id;
        delete data.selected;
        delete data.updatedAt;
        delete data.userId;
        try {
          this.$store.dispatch('changeLoadingJoinnus', true);
          await api.updateBilling(idBilling, data);
          const response = await api.getBillings(userId);
          this.$store.dispatch('setBillings', response.userBillingDetails);
        } catch (error) {
          console.log(error);
        } finally {
          this.$store.dispatch('changeLoadingJoinnus', false);
          this.$store.dispatch('resetFormBilling');
        }
      }
      this.$store.dispatch('changeShowModalBilling', false);
    },
    onReset(event) {
      event.preventDefault();
      this.$store.dispatch('changeShowModalBilling', false);
    },
    async verifySunatApi(data) {
      try {
        this.$store.dispatch('changeLoadingJoinnus', true);
        const response = await api.verificationSunat(data);
        console.log('verifySunatApi', response);
        if (response.message !== 'Número de Documento Invalido') {
          this.setValuesBillingSunatApi(response.data);
        } else {
          this.showAlert();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch('changeLoadingJoinnus', false);
      }
    },
    verifySunat(number, type) {
      const data = {
        documentType: type,
        documentNumber: number
      };
      this.verifySunatApi(data);
    },
    setValuesBillingSunatApi(data) {
      const userBilling = {
        businessName: data.nombre,
        businessIdentifier: data.numeroDocumento,
        email: '',
        addressDepartment: data.departamento,
        addressProvince: data.provincia,
        addressDistrict: data.distrito,
        address: data.direccion
      };
      this.$store.dispatch('setBilling', userBilling);
    }
  }
};
</script>
<style lang="scss" scoped>
.form-billing {
  &-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    margin-top: 1rem;
  }
}
.input-group-append {
  margin-left: -5px;
}
</style>
